import React from 'react';
import { gql } from '@apollo/client';
import { ProductShareFragment, ProductShareVariantFragment } from '../../generated/types';
import { EMAIL_SHARE_FRAGMENT, EMAIL_SHARE_VARIANT_FRAGMENT } from '../EmailShare';
import { ProductShareV2Desktop } from '../ProductShareV2';
import { useNewShareIconFeatureFlag } from '../ProductShareV2/useProductShareV2';
import {
  PINTEREST_SHARE_LINK_FRAGMENT,
  PINTEREST_SHARE_VARIANT_FRAGMENT,
  PinterestShareLink
} from './PinterestShareLink';
import { FacebookShareLink } from './FacebookShareLink';
import { EmailShareLink } from './EmailShareLink';

import './ProductShare.scss';

export const PRODUCT_SHARE_VARIANT_FRAGMENT = gql`
  fragment ProductShareVariantFragment on VariantData {
    ...EmailShareVariantFragment
    ...PinterestShareVariantFragment
  }

  ${EMAIL_SHARE_VARIANT_FRAGMENT}
  ${PINTEREST_SHARE_VARIANT_FRAGMENT}
`;
export const PRODUCT_SHARE_FRAGMENT = gql`
  fragment ProductShareFragment on Variant {
    ...PinterestShareLinkFragment
    ...EmailShareFragment
  }

  ${PINTEREST_SHARE_LINK_FRAGMENT}
  ${EMAIL_SHARE_FRAGMENT}
`;

interface Props {
  variant: ProductShareFragment;
  activeVariant: ProductShareVariantFragment;
}

export const ProductShare: React.FC<Props> = ({ variant, activeVariant }) => {
  const newShareIconEnabled = useNewShareIconFeatureFlag();

  if (newShareIconEnabled) {
    return <ProductShareV2Desktop />;
  }

  return (
    <div className="ProductShare">
      <PinterestShareLink variant={variant} activeVariant={activeVariant} />
      <FacebookShareLink />
      <EmailShareLink variant={variant} activeVariant={activeVariant} />
    </div>
  );
};
